import React from 'react';
import { marked } from 'marked';

interface CompatibilityResultProps {
  content: string;
}

export const CompatibilityResult: React.FC<CompatibilityResultProps> = ({ content }) => {
  return (
    <div className="bg-white/5 border border-purple-300/15 rounded-lg p-6">
      <div
        className="prose prose-invert max-w-none text-purple-100"
        dangerouslySetInnerHTML={{ __html: marked.parse(content, { async: false }) }}
      />
    </div>
  );
};